import { INotificationsState } from "../reducers/notificationsReducer";
import { INotification } from "../../types/notification/inotification.interface";

const defaultNotifications: INotification[] = [];

export const selectNotifications = ({ notifications: { notifications } }: INotificationsState) =>
  notifications || defaultNotifications;

export const selectNotificationCount = ({ notifications: { totalUnread } }: INotificationsState) =>
  totalUnread;

export const selectIsPanelOpen = ({ notifications: { isPanelOpen } }: INotificationsState) =>
  isPanelOpen;
